import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, Col, Module, Row } from 'components/misc'
import { Form, Title } from 'components/layout'
import { FormattedMessage } from 'react-intl'
import { form } from 'helpers/decorators'
import styles from './announcements.styl'
import { connect } from 'react-redux'
import { Select, Textarea } from '../../../../components/fields'
import { Checkbox } from '../../../../components/fields'
import { apiAnnouncements, apiCodeLists } from 'helpers/decorators/api'
import updateValidate from './updateValidate'
import { get } from 'lodash'
import mapSchema from '../../../../models/announcements/mapSchema'




@apiAnnouncements()
@apiCodeLists(['announcementSeverityStates'])
@connect(
  state => ({
    announcement: get(state, 'api.announcements.detail'),
    isLoading: get(state, 'api.announcements.loading')
  }), {}
)
@form({
  form: 'update-announcement',
  initialProps: 'announcement',
  initialPropsMapper: mapSchema,
  disableHook: true,
  validate: updateValidate
})
class Announcements extends Component {
  static propTypes = {
    announcement: PropTypes.object,
    onUpdateAnnouncement: PropTypes.func,
    codeLists: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
    modal: PropTypes.object,
    handleSubmit: PropTypes.func,
    onSubmit: PropTypes.func,
    notification: PropTypes.func,
    logError: PropTypes.func
  }


  handleOnUpdate = (id, values) => {
    this.props.onUpdateAnnouncement(id, values).then(() => {
    }).catch(this.handleError)
  }

  handleError = err => {
    this.props.logError(err)
    this.props.modal(null)
    if (err && err.body) {
      console.debug('error', err.body && err.body.userMessage)
      this.props.notification(err.body.userMessage || 'Error', 'error')
    }
  }

  render () {
    const { announcement, codeLists, handleSubmit, isLoading } = this.props

    return (
      <div className={styles.module_wrapper}>
        <Module verticallyNarrow primary>
          <div className={styles.wrapper}>
            <Row alignItems="center" gutters inner paddingTop>
              <Form>
                <Title h1>
                  <FormattedMessage
                    id="moduleTitle.update_announcement"
                    defaultMessage="Update Announcement"
                  />
                </Title>
                <Col flex="0 1 200px" alignSelf="center">
                  <Select
                    label="Severity"
                    intlKey="label.severity"
                    name="severity"
                    clearable={false}
                    options={get(codeLists, 'announcementSeverityStates.list')}
                  />
                </Col>
                <Col flex="0 1 200px" alignSelf="center">
                  <Textarea
                    label="content"
                    intlKey="label.content"
                    name="content"
                  />
                </Col>
                <Col flex="0 1 200px" alignSelf="center">
                  <Checkbox
                    label="Visible"
                    intlKey="label.is_visible"
                    name="isVisible"
                  />
                </Col>
              </Form>
            </Row>
            <Row alignItems="center" gutters inner paddingTop>
              <Button
                onClick={handleSubmit(fields => this.handleOnUpdate(get(announcement, 'id'), fields))}
                isLoading={isLoading}
                disabled={isLoading}
              >
                <FormattedMessage id="button.update" defaultMessage="Update" />
              </Button>
            </Row>
          </div>
        </Module>
      </div>
    )
  }
}

export default Announcements
